import { ALBUMS } from "../../data/albums";
import AlbumCard from "./AlbumCard";

/**
 * @param {{ onOpenAlbum: (id: string) => void }} props
 */
export default function AlbumsIndex({ onOpenAlbum }) {
  return (
    <div className="albums-page">
      <section className="albums-intro" aria-label="Albums">
        <div className="albums-intro__eyebrow">ALBUMS</div>
        <div className="albums-intro__header">
          <div>
            <h1 className="albums-intro__title">Albums</h1>
            <p className="albums-intro__subtitle">
              Photographs from events I&apos;ve covered — family gatherings,
              retreats, and celebrations along the way. Open an album to browse the full set.
            </p>
          </div>
          <span className="albums-intro__count">{ALBUMS.length} ALBUMS</span>
        </div>
      </section>

      <section className="albums-grid-section" aria-label="Album list">
        <div className="albums-grid">
          {ALBUMS.map((album) => (
            <AlbumCard key={album.id} album={album} onOpen={onOpenAlbum} />
          ))}
        </div>
      </section>
    </div>
  );
}
